import { EditableCheckbox } from 'components/common';

import styles from './PermissionItem.module.scss';

interface Props {
  label: string;
  isEdit: boolean;
  value: boolean;
  onChange: (checked: boolean) => void;
}

export const PermissionItem = ({ label, isEdit, value, onChange }: Props) => {
  return (
    <div className={styles.permissionItem}>
      <EditableCheckbox label={label} editing={isEdit} checked={value} onChange={onChange} />
    </div>
  );
};
